// Google Apps Script 기반 스프레드시트 서비스
// 보안상 더 안전한 대안

class AppScriptService {
  constructor() {
    // Vercel API 엔드포인트 사용 (CORS 문제 해결)
    this.apiUrl = '/api/sheets';
    this.initialized = false;
  }

  // 연결 테스트
  async testConnection() {
    try {


      const response = await fetch(`${this.apiUrl}?action=ping`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      console.log('Vercel API 응답:', {
        status: response.status,
        statusText: response.statusText,
        ok: response.ok
      });

      if (response.ok) {
        const result = await response.json();

        this.initialized = result.success;
        return this.initialized;
      } else {
        throw new Error(`API 요청 실패: ${response.status} ${response.statusText}`);
      }
      
    } catch (error) {
      console.error('Apps Script 연결 테스트 실패:', error);
      this.initialized = false;
      return false;
    }
  }

  // 데이터 추가
  async addData(sheetName, data) {
    try {


      const response = await fetch(this.apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          action: 'addData',
          sheetName: sheetName,
          data: data
        })
      });

      console.log('Vercel API 응답:', {
        status: response.status,
        ok: response.ok
      });

      if (response.ok) {
        const result = await response.json();

        
        if (!result.success) {
          throw new Error(result.error || '데이터 추가 실패');
        }
        
        return result;
      } else {
        const errorText = await response.text();
        throw new Error(`API 요청 실패: ${response.status} ${errorText}`);
      }
      
    } catch (error) {
      console.error('데이터 추가 실패:', error);
      throw error;
    }
  }

  // 데이터 조회
  async getData(sheetName, filters = {}) {
    try {


      const params = new URLSearchParams({
        action: 'getData',
        sheetName: sheetName
      });
      
      // 필터를 개별적으로 추가하여 인코딩 문제 방지
      Object.keys(filters).forEach(key => {
        params.append(key, filters[key]);
      });

      const response = await fetch(`${this.apiUrl}?${params}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      console.log('Vercel API 응답:', {
        status: response.status,
        ok: response.ok
      });

      if (response.ok) {
        const result = await response.json();

        
        if (!result.success) {
          throw new Error(result.error || '데이터 조회 실패');
        }
        
        return result.data || [];
      } else {
        const errorText = await response.text();
        throw new Error(`API 요청 실패: ${response.status} ${errorText}`);
      }
      
    } catch (error) {
      console.error('데이터 조회 실패:', error);
      throw error;
    }
  }

  // 데이터 업데이트
  async updateData(sheetName, rowId, data) {
    try {
      const response = await fetch(this.apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          action: 'updateData',
          sheetName: sheetName,
          rowId: rowId,
          data: data
        })
      });

      if (response.ok) {
        const result = await response.json();
        if (!result.success) {
          throw new Error(result.error || '데이터 업데이트 실패');
        }
        return result;
      } else {
        const errorText = await response.text();
        throw new Error(`API 요청 실패: ${response.status} ${errorText}`);
      }
      
    } catch (error) {
      console.error('데이터 업데이트 실패:', error);
      throw error;
    }
  }

  // 시트 초기화
  async clearSheet(sheetName) {
    try {
      const response = await fetch(this.apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          action: 'clearSheet',
          sheetName: sheetName
        })
      });

      if (response.ok) {
        const result = await response.json();
        return result.success;
      }
      return false;
      
    } catch (error) {
      console.error('시트 초기화 실패:', error);
      return false;
    }
  }

  // 시트 목록 가져오기
  async getSheetList() {
    try {
      const response = await fetch(`${this.apiUrl}?action=getSheetList`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        const result = await response.json();
        return result.success ? result.data : [];
      }
      return [];
      
    } catch (error) {
      console.error('시트 목록 조회 실패:', error);
      return [];
    }
  }

  // TTS 스크립트 조회 (특별 기능)
  async getTTSScripts(courseId = 'LM2001020230') {
    try {
      const params = new URLSearchParams({
        action: 'getData',
        sheetName: 'TTS_Scripts',
        courseId: courseId
      });

      const response = await fetch(`${this.apiUrl}?${params}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        const result = await response.json();
        if (!result.success) {
          throw new Error(result.error || 'TTS 스크립트 조회 실패');
        }
        
        // 데이터를 섹션 배열 형태로 변환
        const scripts = result.data || [];
        

        
        // 첫 번째 항목에서 course_title 추출
        const courseTitle = scripts.length > 0 ? scripts[0].course_title : "프로그래밍 언어 응용 가이드";
        
        const sections = scripts
          .filter(s => s.section_order > 0)
          .sort((a, b) => a.section_order - b.section_order)
          .map(script => ({
            section_order: script.section_order,
            section_title: script.section_title,
            section_content: script.section_content,
            // 하위 호환성을 위해 기존 필드도 유지
            title: script.section_title,
            content: script.section_content
          }));
          

        
        return {
          title: courseTitle,
          sections: sections
        };
      } else {
        const errorText = await response.text();
        throw new Error(`API 요청 실패: ${response.status} ${errorText}`);
      }
    } catch (error) {
      console.error('TTS 스크립트 조회 실패:', error);
      // 실패시 기본 스크립트 반환
      return this.getDefaultScript();
    }
  }

  // 기본 스크립트 (fallback)
  getDefaultScript() {
    return {
      title: "LM2001020230 프로그래밍 언어 응용 완전 가이드",
      sections: [
        {
          title: "인트로 및 과정 개요",
          content: "기본 인트로 내용입니다. 구글 시트에서 데이터를 불러올 수 없을 때 표시됩니다."
        }
      ]
    };
  }
}

// 싱글톤 인스턴스
const appScriptService = new AppScriptService();

export default appScriptService;